import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

(function($) {
    function initResourceSwiper() {
        var $resourceSliders = $('.resource-slider');

        $resourceSliders.each(function() {
            var $resourceSlider = $(this);

            const resourceSwiper = new Swiper($resourceSlider[0].querySelector('.resource-swiper'), {
                modules: [Navigation],
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: false,
                loop: false,
                navigation: {
                    prevEl: $resourceSlider[0].querySelector('.slider-prev'),
                    nextEl: $resourceSlider[0].querySelector('.slider-next'),
                },
            });
        });
    }

    // Initialize on page load
    initResourceSwiper();

    // Re-initialize on window resize
    window.addEventListener('resize', () => {
        initResourceSwiper();
    });
}(jQuery));